// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__Glds5","story":"Avatar_story__rZQj7"};